import '@/modules/product-modal';

import ProductForm from '@/modules/product-form'
import TestimonialCarousel from '@/modules/testimonial-carousel';
import StepsCarousel from '@/modules/steps-carousel';
import RelatedProductsCarousel from '@/modules/related-products-carousel';

if (document.getElementsByTagName('product-form')) {
    customElements.define('product-form', ProductForm);
}

if (document.querySelector('.js-testimonial-carousel')) {
    new TestimonialCarousel(document.querySelector('.js-testimonial-carousel'));
}

if (document.querySelector('.js-steps-carousel')) {
    new StepsCarousel(document.querySelector('.js-steps-carousel'));
}

if (document.querySelector('.js-related-products-carousel')) {
    new RelatedProductsCarousel(document.querySelector('.js-related-products-carousel'));
}
